class AnimateIn extends window.BAO.CustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    this.splitWords()

    const amountIntoViewport = window.BAO.MediaBreakpoints.isSm
      ? '-60px'
      : '-50px'

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: amountIntoViewport,
      threshold: 0,
    })

    this.observer.observe(this)
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    this.setAttribute('animate', '')

    observer.unobserve(this)
  }

  splitWords () {
    if (!this.els?.title?.exists) return

    this.els.title.elements.forEach((titleEl) => {
      const wordsArray = titleEl.innerText.replace(/\n/g, ' <br> ').split(' ')
      let titleContent = ''

      wordsArray.forEach((word) => {
        titleContent +=
          word === '<br>'
            ? `<br>`
            : `<span class="ani-Title"><span class="ani-Title_Word">${word}</span></span> `
      })

      titleEl.innerHTML = titleContent
    })
  }
}

if (!customElements.get('animate-in')) {
  customElements.define('animate-in', AnimateIn)
}
